module.exports = __webpack_public_path__ + "img/download.7833c988.svg";